import { useEffect } from 'react'
import '../../css/Member.css'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import { useAppContext } from '../../components/provider/AppProvider'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import { postKakaoSocialLogin } from '../../api/login'
import { postOpenid } from '../../api/auth'
import { handleAccessToken } from '../../js/script'
import { useMyContext } from '../../components/provider/MyProvider'

export default function SignIntro({ setText, closeModal, setAuthType, setKakaoUserData, setKakaoToken }: any) {
  const { isAppView } = useAppContext()
  const { setIsToast, setToastMessage } = useMyContext()
  const navigate = useNavigate()

  const createEventInfo = () => ({
    event_info: {
      method: 'non-members',
    },
    user_info: {
      login_status: 'N',
      user_id: undefined,
    },
  })

  const createEventClickNonMember = (eventInfo: ReturnType<typeof createEventInfo>): DataLayerArgs => ({
    dataLayer: {
      event: 'click_non-member',
      ...eventInfo,
    },
  })

  const handleGaEvent = () => {
    const eventInfo = createEventInfo()
    const nonMemberClick = createEventClickNonMember(eventInfo)

    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'click_non-member',
        eventType: eventInfo,
      })
    } else {
      TagManager.dataLayer(nonMemberClick)
    }
  }

  const NonMemberButtonHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    handleGaEvent()
    closeModal()
    navigate('/')
  }

  useEffect(() => {
    const handleMessage = (event: any) => {
      // 보안 체크: 새 창의 도메인 확인
      if (event.origin !== process.env.REACT_APP_SHOP_URL) return
      if (event.data.kakaoToken && event.data.userData) {
        console.log(event.data.userData)
        postKakaoSocialLogin(
          String(event.data.userData.id),
          event.data.kakaoToken,
          event.data.userData.kakao_account.phone_number.replace('+82 10-', '010-').replace(/-/g, '')
        )
          .then((res) => {
            if (res.data.code === 'E0123') {
              setText('agree')
              setKakaoUserData(event.data.userData)
              setKakaoToken(event.data.kakaoToken)
              setAuthType(`kakao`)
            } else if (res.data.code === 'E0127') {
              alert('회원탈퇴 한지 7일이 지나지 않았습니다.')
            } else if (res.data.code === 'E0125') {
              alert('회원탈퇴 한지 180일이 지나지 않았습니다.')
            } else if (res.data.code === 'E0111') {
              navigate(`/sanctions`, {
                state: { userData: res.data },
              })
            } else {
              window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify(res.data.refreshToken))
              window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))
              postOpenid(res.data.accessToken).then((response) => {
                window.localStorage.setItem(`accessToken`, JSON.stringify(response.data.accessToken))
                setToastMessage('로그인이 완료 되었어요.')
                setIsToast(true)
                handleAccessToken()
                setTimeout(() => {
                  closeModal()
                  navigate('/')
                }, 500)
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
      // 받은 URL을 처리하는 로직 추가
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <>
      <div className='sign_intro_wrap'>
        <div className='btn_box'>
          <button
            className='close_btn'
            type='button'
            onClick={() => {
              closeModal()
            }}
          >
            <img src='/images/icon_w_close.png' alt='' />
          </button>
        </div>
        <div className='sign_intro_cont'>
          <div className='top_box'>
            <h1>
              <img src='/images/logo_w.png' alt='' />
            </h1>
            <p>#신규가입혜택</p>
            <h2>
              가입 즉시 <b>3만원</b> 적립
            </h2>
          </div>
          <div className='bot_bot'>
            <div className='btn_item'>
              <button
                className='btn_kakao'
                onClick={() => {
                  const open = window.open('about:blank', '_blank')
                  if (open) {
                    open.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_SHOP_URL}/myshopping/oauth&response_type=code`
                  }
                }}
              >
                <img src='/images/kakao.png' alt='' style={{ width: 20, height: 20 }} />
                카카오로 시작하기
                <div style={{ width: 20, height: 20 }}></div>
              </button>
              {/* <button
                onClick={(e) => {
                  e.preventDefault()
                  setText('login')
                }}
              >
                애플로 시작하기
              </button> */}
              <button
                onClick={(e) => {
                  e.preventDefault()
                  setText('login')
                }}
                className='btn_other'
                style={{ background: '#000000', color: '#FFFFFF' }}
              >
                <div style={{ width: 20, height: 20 }}></div>
                다른방법으로 로그인
                <div style={{ width: 20, height: 20 }}></div>
              </button>
              <button onClick={NonMemberButtonHandler} className='btn_nonmember'>
                <div style={{ width: 20, height: 20 }}></div>
                둘러보기
                <div style={{ width: 20, height: 20 }}></div>
              </button>
            </div>
            {/* <div className='web_box'>
              <p>편리한 로그인을 위해 앱을 설치해 보세요.</p>
              <a href='https://aboutfishing.onelink.me/oR5G/ggsxif1g'>
                앱 설치하러 가기
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}
